import React, { useState } from "react";
import { VStack } from "@chakra-ui/react";
import { Onboarding, LanguageLevelOnboarding } from "@shared_types";
import OnboardingLayout from "./OnboardingLayout";
import LevelIcon from "./LevelIcon";
import OnboardingRectangleCard from "../Cards/OnboardingRectangleCard";

interface LevelOption {
  value: Onboarding["currentSpanishLevel"];
  label: string;
  description?: string;
  icon: React.ReactNode;
}

interface SpanishLevelStepProps {
  level?: LanguageLevelOnboarding | null;
  setLevel: (level: LanguageLevelOnboarding) => void;
}

const SpanishLevelStep: React.FC<SpanishLevelStepProps> = ({
  level,
  setLevel,
}) => {
  const [selectedLevel, setSelectedLevel] = useState<string | null>(
    level ?? null
  );
  const handleSelect = (level: Onboarding["currentSpanishLevel"]) => {
    setSelectedLevel(level);
    setLevel(level);
  };

  const levelOptions: LevelOption[] = [
    {
      value: "im_new_to_the_language",
      label: "I'm new to Spanish",
      // super begginer
      icon: <LevelIcon color="var(--color-blue)" />,
    },
    {
      value: "i_know_some_common_words",
      label: "I know some common words",
      // super beginner
      icon: <LevelIcon color="var(--color-blue)" activeBars={1} />,
    },
    {
      value: "i_can_have_basic_conversations",
      label: "I can have basic conversations",
      // beginner
      icon: <LevelIcon color="var(--color-blue)" activeBars={2} />,
    },
    {
      value: "i_can_talk_about_various_topics",
      label: "I can talk about various topics",
      icon: <LevelIcon color="var(--color-blue)" activeBars={3} />,
    },
    {
      value: "i_can_discuss_most_topics_in_detail",
      label: "I can discuss most topics in detail",
      icon: <LevelIcon color="var(--color-blue)" activeBars={4} />,
    },
  ];

  return (
    <OnboardingLayout
      title="What's your current Spanish level?"
      subtitle="This helps us personalize your learning experience"
    >
      <VStack
        gap={4}
        alignItems={"center"}
        justifyItems={"center"}
        maxW="600px"
        margin="0 auto"
        width={"full"}
      >
        {levelOptions.map((option, index) => (
          <OnboardingRectangleCard
            key={index}
            emoji={option.icon}
            title={option.label}
            selected={selectedLevel === option.value}
            onClick={() => handleSelect(option.value)}
          />
        ))}
      </VStack>
    </OnboardingLayout>
  );
};

export default SpanishLevelStep;
